import React, { useCallback, useContext } from 'react'
import { HeaderGlobalNav, HeaderToolsNav } from '@grammarly/website-components'
import { useRouter } from 'next/dist/client/router'
import {
  useBrowserService,
  useExperimentService,
  useUserService,
  useToolsLtvNav,
  useLocalization,
  useLanguage,
} from '../../../../lib/hooks'
import { EventProps, gnarClient } from '../../../../lib/tracking/gnar'
import { PageContext } from '../../../../contexts/page-context'
import { getConfig } from '../../../../config'
import { withPublicAssetUrl } from '../../../../lib/utils/cdn'
import { extractUtmParams } from '../../../../lib/utils/url'
import { FreeTrialButton } from '../../../free-trial-button'

const baseDomain = getConfig().domains.main
const shBaseDomain = getConfig().domains.superhuman

interface HeaderGlobalProps {
  ctas?: React.ReactNode
  secondaryHeader?: React.ReactNode
}

export const HeaderGlobal: React.FC<HeaderGlobalProps> = (props) => {
  const { pageId, slug } = useContext(PageContext)
  const { isAnonymous } = useUserService().currentUser
  const { isMobileOrTablet } = useBrowserService()
  const exp = useExperimentService()
  const { isLtvNavExperiment } = useToolsLtvNav()
  const { locale } = useLocalization()
  const { lang } = useLanguage()

  const gnarTrackFn = useCallback(
    (trackEventProps: EventProps) => {
      return gnarClient.track({ ...trackEventProps, pageId, pageSlug: slug })
    },
    [pageId, slug]
  )
  const { query } = useRouter()
  const utmQueryParams = extractUtmParams(query)

  const isSpanish = locale === 'es-US' || lang === 'es'

  const globalNavAnonymousTrialUphookAssignment = exp.getGlobalNavAnonymousTrialUphookAssignment()
  const showFreeTrialCta =
    isAnonymous &&
    (globalNavAnonymousTrialUphookAssignment === 'cleaner_global_nav_w_free_trial_uphook' ||
      globalNavAnonymousTrialUphookAssignment === 'busy_global_nav_w_free_trial_upook')

  if (isSpanish) {
    return (
      <HeaderToolsNav
        clientName="cms"
        baseDomain={baseDomain}
        shBaseDomain={shBaseDomain}
        gnarTrackFn={gnarTrackFn}
        isLoggedIn={!isAnonymous}
        isMobileTablet={isMobileOrTablet}
        ctas={props.ctas}
        sticky
      />
    )
  }

  return (
    <HeaderGlobalNav
      clientName="cms"
      baseDomain={baseDomain}
      shBaseDomain={shBaseDomain}
      gnarTrackFn={gnarTrackFn}
      isLoggedIn={!isAnonymous}
      isMobileTablet={isMobileOrTablet}
      secondaryHeader={props.secondaryHeader}
      ctas={props.ctas}
      sticky
      headerItemImages={{ mainStandWithUkraine: withPublicAssetUrl('header/ukraine-grammarly-logo.png') }}
      queryParams={{ utmParams: utmQueryParams }}
      isWhatsNewItemVisible={exp.isWhatsNewHeaderItem_25Enabled}
      isLtvNavCtaFirst={isLtvNavExperiment}
      hideContactSales={
        isAnonymous && globalNavAnonymousTrialUphookAssignment === 'cleaner_global_nav_w_free_trial_uphook'
      }
      customCta={showFreeTrialCta && <FreeTrialButton />}
    />
  )
}
